/* global axios */
import ApiClient from './ApiClient';

class InboxTeams extends ApiClient {
  constructor() {
    super('inbox_teams', { accountScoped: true });
  }

  update({ inboxId, teamIds }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      team_ids: teamIds,
    });
  }
}

export default new InboxTeams();
